// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/core/svc_patient_document.proto (package com.diagnocat.core, syntax proto3)
/* eslint-disable */

import { AddPatientDocumentImageReq, AddPatientDocumentImageResp, CreatePatientDocumentReq, CreatePatientDocumentResp, DeletePatientDocumentReq, DeletePatientDocumentResp, GetPatientDocumentReq, GetPatientDocumentResp, ListPatientDocumentSourceAssetsReq, ListPatientDocumentSourceAssetsResp, ListPatientDocumentsReq, ListPatientDocumentsResp, RemovePatientDocumentImageReq, RemovePatientDocumentImageResp, ReorderPatientDocumentImagesReq, ReorderPatientDocumentImagesResp, UpdatePatientDocumentImageReq, UpdatePatientDocumentImageResp, UpdatePatientDocumentReq, UpdatePatientDocumentResp } from "./svc_patient_document_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service com.diagnocat.core.PatientDocumentService
 */
export const PatientDocumentService = {
  typeName: "com.diagnocat.core.PatientDocumentService",
  methods: {
    /**
     * @generated from rpc com.diagnocat.core.PatientDocumentService.ListPatientDocuments
     */
    listPatientDocuments: {
      name: "ListPatientDocuments",
      I: ListPatientDocumentsReq,
      O: ListPatientDocumentsResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.core.PatientDocumentService.GetPatientDocument
     */
    getPatientDocument: {
      name: "GetPatientDocument",
      I: GetPatientDocumentReq,
      O: GetPatientDocumentResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.core.PatientDocumentService.CreatePatientDocument
     */
    createPatientDocument: {
      name: "CreatePatientDocument",
      I: CreatePatientDocumentReq,
      O: CreatePatientDocumentResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.core.PatientDocumentService.UpdatePatientDocument
     */
    updatePatientDocument: {
      name: "UpdatePatientDocument",
      I: UpdatePatientDocumentReq,
      O: UpdatePatientDocumentResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.core.PatientDocumentService.DeletePatientDocument
     */
    deletePatientDocument: {
      name: "DeletePatientDocument",
      I: DeletePatientDocumentReq,
      O: DeletePatientDocumentResp,
      kind: MethodKind.Unary,
    },
    /**
     * Image-reference mutations. A user-uploaded image first becomes a patient
     * asset (AssetType_Patient_UploadedImage) through the standard upload session;
     * these mutations only manage a document's ordered references and their
     * presentation metadata (caption + view options). Core allocates the
     * document-local image serial atomically with the revision update; clients and
     * agents never choose IDs. All mutations are optimistic-concurrency guarded by
     * ExpectedRevision.
     *
     * @generated from rpc com.diagnocat.core.PatientDocumentService.AddPatientDocumentImage
     */
    addPatientDocumentImage: {
      name: "AddPatientDocumentImage",
      I: AddPatientDocumentImageReq,
      O: AddPatientDocumentImageResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.core.PatientDocumentService.UpdatePatientDocumentImage
     */
    updatePatientDocumentImage: {
      name: "UpdatePatientDocumentImage",
      I: UpdatePatientDocumentImageReq,
      O: UpdatePatientDocumentImageResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.core.PatientDocumentService.ReorderPatientDocumentImages
     */
    reorderPatientDocumentImages: {
      name: "ReorderPatientDocumentImages",
      I: ReorderPatientDocumentImagesReq,
      O: ReorderPatientDocumentImagesResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.core.PatientDocumentService.RemovePatientDocumentImage
     */
    removePatientDocumentImage: {
      name: "RemovePatientDocumentImage",
      I: RemovePatientDocumentImageReq,
      O: RemovePatientDocumentImageResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.core.PatientDocumentService.ListPatientDocumentSourceAssets
     */
    listPatientDocumentSourceAssets: {
      name: "ListPatientDocumentSourceAssets",
      I: ListPatientDocumentSourceAssetsReq,
      O: ListPatientDocumentSourceAssetsResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

